import { recStatusModify } from "../../../../../../../utils/rec-status.modify";

export const modifyInformationNCM = async (dados: any) => {
  await dados.forEach((ncm: any) => {
    ncm.ncmsRecStatus = recStatusModify.table(ncm.ncmsRecStatus)
    return dados;
  });
};
